module.exports = __webpack_public_path__ + "ddafb6f7c4e34754f7876e81a2adf856.png";